import { useCallback } from 'react'

import { Place } from 'components/Place/Place'
import { Loading } from 'components/ui/Loading/Loading'
import { ContainerType, useWarehouseStock } from 'services/warehouse-containers/containers'
import { WarehouseType } from 'services/warehouse-containers/warehouse'
import { ContainerTypeLink } from 'components/ContainerTypeLink/ContainerTypeLink'

export const Management = () => {
  const { isLoading, args, setArgs: setWarehouse, containerTypes } = useWarehouseStock()

  const renderContainerTypeItem = (containerType: ContainerType, index: number) => (
    <ContainerTypeLink key={index} containerType={containerType} />
  )

  const renderContainerTypeList = useCallback(() => {
    if (isLoading) return <Loading />

    return <div>{containerTypes?.map(renderContainerTypeItem)}</div>
  }, [containerTypes?.length, isLoading])

  return (
    <>
      <Place
        title="Баланс склада"
        hint="Выберите склад для просмотра количества контейнеров, которые на нем присутствуют"
        warehouse={args}
        onSearch={setWarehouse}
        warehouseTypes={[WarehouseType.MiniWarehouse, WarehouseType.Courier]}
      />
      {renderContainerTypeList()}
    </>
  )
}
